<app-data-set
	#dataSet
	[dataSource]="dataSource"
	defaultPresentationMode="table"
	firstColumnProperty="group.name"
	[rowId]="rowId"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="name"
				[defaultFilterLabel]="filterLabels.groupName"
				[placeholder]="filterLabels.defaultPlaceholder"
				i18n-placeholder="@@deviceGroupsComponent-searchGroupName"
			>
				<div class="filter-grid" [style.--columns]="1">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.groupName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('name')"
								data-automation-id="group-name-input"
								(ngModelChange)="dataSet.filter('name', filterLabels.groupName, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (allowDeviceWrites) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add"
					i18n-label="@@device-groupsAdd"
					data-automation-id="add-to-device-group-button"
					(click)="navigateToAddDeviceGroup()"
				></app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getDeviceGroupsLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getDeviceGroupsLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>
				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@device-groupsGroupName2">Group Name</th>
					<td mat-cell *matCellDef="let row">{{ row.group.name }}</td>
				</ng-container>

				<ng-container matColumnDef="deviceCount">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@device-groupsDevice(s)">Device(s)</th>
					<td mat-cell *matCellDef="let row">{{ row.deviceCount }}</td>
				</ng-container>

				<ng-container matColumnDef="source">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@device-source">Source</th>
					<td mat-cell *matCellDef="let row">
						<div class="source-container row-left spacing-8">
							@if (isOwnedDeviceGroup(row.group)) {
								<mat-icon class="icon-device-group-owned" svgIcon="sl-device-group-owned"></mat-icon>
							} @else {
								<mat-icon class="icon-device-group-inherited" svgIcon="sl-device-group-inherited"></mat-icon>
							}
							{{ row.source.companyName }}
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row" class="padding-right-30">
						@if (canShowDeviceGroupRowMenu(row)) {
							@if (isEmbeddedInCompanyDetail) {
								<app-data-set-table-menu [menu]="menu" [row]="row"></app-data-set-table-menu>
							} @else {
								<app-data-set-table-menu
									[menu]="menu"
									[row]="row"
									[appHasSystemCapability]
									has="deviceManagement"
								></app-data-set-table-menu>
							}
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(click)="onRowClick(row)"
					[attr.data-automation-id]="'device-group-row-' + row.id"
				></tr>
			</table>

			<mat-menu #menu="matMenu">
				<ng-template matMenuContent let-row="row">
					<button
						mat-menu-item
						(click)="renameGroupMenuOptionClicked(row)"
						i18n="@@deviceGroup-renameGroup"
						data-automation-id="rename-device-group-button"
					>
						Rename Group
					</button>
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
